import { parseDateTime } from 'utils/dates/date.utils';

export const formatDate = (dateTime, fallback) => {
  const date = parseDateTime(dateTime);
  if (!date) return fallback;

  return new Intl.DateTimeFormat(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
};

export const getDay15ForecastPageHeading = (forecast = []) => {
  if (!forecast.length) return null;

  const firstDate = formatDate(forecast[0]?.iso8601);
  const lastDate = formatDate(forecast[forecast.length - 1]?.iso8601);

  if (!firstDate || !lastDate) return '15-Day Weather Forecast';

  return `${firstDate} - ${lastDate} Weather Forecast`;
};

export const getDay15ForecastCardTitle = (forecast) => {
  return formatDate(forecast?.iso8601, 'Forecast');
};
